import * as React from 'react';

export const StopPropagation: React.FC<{ as?: string; className?: string }> = ({ as, className, children }) => {
  const onClick = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  }, []);

  return React.createElement(as || 'span', { onClick, className }, children);
};
